import type { Placement as CorePlacement } from '@sch-inventory/advertory/types/core/interface/config';
import type { DeviceType } from '@innhold/core/device/types';
import { getDesktopPlacements } from './desktop';
import { getMobilePlacements } from './mobile';
import { getTabletPlacements } from './tablet';

export type Placement = CorePlacement & {
    subtype: string;
    format?: string[];
    group?: string;
    lazyload?: boolean;
    safeframe?: boolean;
    videoEnabled?: boolean;
};

export const getPlacements = (areAdsBlocked?: boolean) => {
    const isAdblockEnabled = !!areAdsBlocked;

    return {
        mobile: getMobilePlacements(isAdblockEnabled),
        tablet: getTabletPlacements(isAdblockEnabled),
        desktop: getDesktopPlacements(isAdblockEnabled),
    };
};

export function getPlacementsForDevice(deviceType: DeviceType) {
    const placements = getPlacements() as { [K in DeviceType]: Placement[] };

    return placements[deviceType] ?? [];
}
